
	module.exports = require('./accessors').AlphaAccessor;




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/color/AlphaAccessor.js
// module id = 3065
// module chunks = 15